<template>
  <div class="doc-wrapper">
    <div class="row">
      <ModelSelect
        label="Название проекта"
        item-value="id"
        item-text="field_value"
        :items="dictionaryByType('project_history')"
        v-model="project.foreignSeasonId"
      />

      <ModelSelect
        label="Результат участия"
        item-value="id"
        item-text="field_value"
        :items="dictionaryByType('stage_history')"
        v-model="project.foreignResultId"
      />
      <div></div>
    </div>

    <div class="row">
      <div class="label">Период участия</div>
    </div>

    <div class="row extra-mb">
      <div>
        <ModelISO class="subtitle" label="Начало" v-model="project.dateBegin" />
      </div>

      <div>
        <ModelISO
          class="subtitle"
          label="Окончание"
          v-model="project.dateEnd"
        />
      </div>

      <div></div>
    </div>

    <div class="row w-100">
      <ModelTextArea
        label="Опишите суть проекта и свои достижения в нем"
        :maxlength="300"
        v-model="project.summary"
      />
    </div>
  </div>
</template>

<script>
import ModelISO from "../../../UI/models/ModelISO";
import ModelSelect from "../../../UI/models/ModelSelect";
import ModelTextArea from "../../../UI/models/ModelTextArea";
import { mapActions, mapGetters } from "vuex";

const getters = ["dictionaryByType"];

const actions = ["loadDictionaryItems"];

export default {
    name: "WideDoc",
    props: {
        project: Object,
    },
    data: () => ({}),
    methods: {
        ...mapActions(actions),
    },
    computed: {
        ...mapGetters(getters),
    },
    model: {
        prop: "project",
        event: "change",
    },
    mounted() {
        this.loadDictionaryItems("project_history");
        this.loadDictionaryItems("stage_history");
    },
    components: {
        ModelISO,
        ModelSelect,
        ModelTextArea,
    },
};
</script>

<style lang="scss" scoped>
@import "../../../../styles/rem";

.row {
  display: flex;
  justify-content: space-between;
  margin-left: unset !important;
  margin-right: unset !important;

  > * {
    width: rem(471);
  }

  .label {
    margin-top: rem(22);
    font-size: rem(16);
    line-height: rem(20);
    font-weight: 600;
    color: #2a2626;
  }

  .subtitle {
    font-family: "Open Sans", sans-serif;
    font-size: rem(16);
    line-height: rem(22);
    color: #2a2626;
  }

  .extra-mb {
    margin-bottom: rem(6);
  }
}

.w-100 .data-model {
  width: 100%;
}

@import "../../../../styles/variables";
@media (max-width: $vm) {
  .doc-wrapper .row {
    flex-direction: column;

    > * {
      width: 100%;
    }

    .label {
      font-size: mrem(16);
      line-height: mrem(20);
      margin: 0 0 mrem(16) 0;
    }
  }

  .row:first-of-type {
    margin-bottom: mrem(24);
  }
}
</style>
